import { TEXT_FALLBACK } from 'Components/Account/AccountPage.consts';
import type { AmountFallback } from 'Components/Account/AccountPage.types';
import { triggerCompletePurchasesPricePopoverSuccessEvent } from 'Services/analytics/events';

export const shouldDisplayFeesView = (hasFees: boolean): boolean => hasFees;

export const showDisplayBiddingView = (hasFees: boolean): boolean => !shouldDisplayFeesView(hasFees);

export const getValueToDisplay = (
	hasFees: boolean,
	value: number,
	totalPaymentAmount?: number,
): number | AmountFallback => {
	if (hasFees && totalPaymentAmount) {
		return totalPaymentAmount;
	}

	if (value) {
		return value;
	}

	return TEXT_FALLBACK;
};

export const sendPricePopoverEvents = (): void => {
	triggerCompletePurchasesPricePopoverSuccessEvent();
};

export const isVehiclePriceFallback = (value: unknown): value is AmountFallback => {
	return value === TEXT_FALLBACK;
};
